import Field from "components/molecules/Field";
import React, {useState} from "react";
import styled from "styled-components";

const StyledColoursSection = styled.div`
    width: 100%;
    padding: 30px 15px;
    .label {
        display: block;
        font-size: 18px;
        line-height: 22px;
        font-weight: 400;
        margin-bottom: 15px;
    }
    .inputs-wrap {
        display: flex;
        gap: 10px;
        .colorPicker {
            width: 55px;
            height: 55px;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 10px;
            outline: none;
            background-color: var(--white);
            padding: 6px;
            cursor: pointer;
            flex-shrink: 0;
            &::-webkit-color-swatch {
                border: none;
                border-radius: 5px;
            }
        }
        .colorInput {
            height: 55px;
            border-radius: 10px;
            border: 1px solid rgba(236, 236, 236, 1);
        }
    }
`;

const ColoursSection = () => {
    const [colors, setColors] = useState({
        color1: "#0287d3",
        color2: "#e6f3fb",
        color3: "#3e3e3e",
    });
    return (
        <StyledColoursSection>
            <strong className="label">Primary Color</strong>
            <div className="inputs-wrap">
                <input
                    type="color"
                    value={colors?.color1}
                    className="colorPicker"
                    onChange={e => setColors(prev => ({...prev, color1: e?.target?.value}))}
                />
                <Field
                    type="text"
                    value={colors?.color1}
                    placeholder="#000000"
                    name="color1"
                    $bgWhite
                    className="colorInput"
                    onChange={e => setColors(prev => ({...prev, color1: e?.target?.value}))}
                />
            </div>
            <strong className="label">Background Color</strong>
            <div className="inputs-wrap">
                <input
                    type="color"
                    value={colors?.color2}
                    className="colorPicker"
                    onChange={e => setColors(prev => ({...prev, color2: e?.target?.value}))}
                />
                <Field
                    type="text"
                    value={colors?.color2}
                    placeholder="#000000"
                    name="color2"
                    $bgWhite
                    className="colorInput"
                    onChange={e => setColors(prev => ({...prev, color2: e?.target?.value}))}
                />
            </div>
            <strong className="label">Text Color</strong>
            <div className="inputs-wrap">
                <input
                    type="color"
                    value={colors?.color3}
                    className="colorPicker"
                    onChange={e => setColors(prev => ({...prev, color3: e?.target?.value}))}
                />
                <Field
                    type="text"
                    value={colors?.color3}
                    placeholder="#000000"
                    name="color3"
                    $bgWhite
                    className="colorInput"
                    onChange={e => setColors(prev => ({...prev, color3: e?.target?.value}))}
                />
            </div>
        </StyledColoursSection>
    );
};

export default ColoursSection;
